"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = isAllEmpty;

var _isEmpty = _interopRequireDefault(require("./isEmpty"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

// If one of the fields is empty. It will return true.
function isAllEmpty(row) {
  var validate = Object.values(row).map(function (column) {
    return (0, _isEmpty["default"])(column);
  });
  var result = validate.filter(function (obj) {
    return obj !== false;
  });
  return result.length >= 1;
}